import { Injectable, signal } from '@angular/core';
import { RecyclingPoint } from '../../types/recycling-point.interface';

/**
 * Service to share point data between components when using custom navigation
 * This replaces Angular Router's state parameter for passing point data to edit-point
 */
@Injectable({
  providedIn: 'root'
})
export class PointDataService {
  private pointForEditSignal = signal<RecyclingPoint | null>(null);

  /**
   * Set point data for editing
   * Call this before navigating to edit-point page
   */
  setPointForEdit(point: RecyclingPoint): void {
    this.pointForEditSignal.set(point);
  }

  /**
   * Get point data for editing
   * Call this in edit-point component to retrieve the data
   */
  getPointForEdit(): RecyclingPoint | null {
    return this.pointForEditSignal();
  }

  /**
   * Clear point data after use
   * Call this after successfully using the data or when navigating away
   */
  clearPointData(): void {
    this.pointForEditSignal.set(null);
  }
}